import { Link } from "react-router";
import { User } from "lucide-react";
import { Icon } from "../../ui";

/**
 * Corporate accounts (desktop kit trade band). Promises only what an approved account gets
 * today: one login and one percentage off parts. No credit terms, no discount on delivery.
 */
export function CorporateBand() {
  return (
    <section className="grid items-center gap-6 rounded-xl bg-surface-brand-alt px-6 py-8 sm:px-10 sm:py-10 lg:grid-cols-[1fr_auto] lg:gap-10">
      <div>
        <p className="mb-3 type-eyebrow tracking-[var(--tracking-widest)] text-blue-200 uppercase">Corporate accounts</p>
        <h2 className="mb-2 type-h2 [font-size:var(--text-xl)] text-white">Running a shop or a fleet?</h2>
        <p className="mb-0 max-w-[560px] type-small text-blue-100">
          One login for your business, and a discount on every part. Apply once; when we approve it, every part shows your company's price. Delivery is charged as usual.
        </p>
      </div>
      <Link
        to="/corporate"
        className="inline-flex h-(--control-lg) items-center justify-center gap-2 rounded-sm border border-green-700 bg-green-700 px-6 type-label [font-size:var(--text-md)] font-bold text-white hover:bg-green-800"
      >
        <Icon icon={User} size={20} />
        <span>Apply for an account</span>
      </Link>
    </section>
  );
}
